import paymentlogin from "@/api/payment-login";

export default {
  state: {},
  mutations: {},
  actions: {
    async loginlogView() {
      try {
        let params = {
          ope: "4"
        };
        let res = await paymentlogin.loginlog(params);
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async loginlogStart(context, { addr, tmp }) {
      try {
        let params = {
          addr: addr,
          tmp: tmp,
          ope: "5"
        };
        let res = await paymentlogin.loginlog(params);
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async loginlogSuccess(context, { addr, tmp }) {
      try {
        let params = {
          addr: addr,
          tmp: tmp,
          ope: "6",
          account_id: await context.dispatch("showAccountID"),
        };
        let res = await paymentlogin.loginlogSuccess(params);
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    async loginlogFail(context, { addr, tmp, errcode }) {
      try {
        let params = {
          addr: addr,
          tmp: tmp,
          ope: "7",
          errcode: errcode
        };
        let res = await paymentlogin.loginlog(params);
        return res;
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
  },
  getters: {}
};
